// hooks/useCreateNewReservation.ts
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store"; // Adjust the import based on your file structure
import { CompleteStripePaymentData, CompleteVoucherStripePaymentData } from "../../api/types";
import Logger from "../helpers/logger";
import ErrorTracker from "../helpers/errorTracker";
import {
  paymentCompleted,
  paymentCompletionBegan,
  paymentCompletionFailed,
} from "../slice/bookingCreation/bookingCreationSlice";

import { useCompleteVoucherStripePaymentMutation } from "../../api/payments/paymentsApiSlice";
import { useCallback } from "react";
import KolulaStorageManager from "../../storage/KolulaStorageManager";
import { enqueueNotification } from "../slice/notification/notificationSlice";
import { t } from "i18next";

export const useCompleteVoucherStripePayment = () => {
  const contact = useSelector(
    (state: RootState) => state.bookingCreation.personalData
  );

  const [completeVoucherStripePaymentMutation] = useCompleteVoucherStripePaymentMutation();
  const dispatch = useDispatch();

  // Use useCallback to memoize the completeStripePayment function
  return useCallback(
    async (sessionId: string) => {
      dispatch(paymentCompletionBegan());

      try {
        if (sessionId && contact) {
          const payload: CompleteVoucherStripePaymentData = {
            sessionId: sessionId,
          };

          const response = await completeVoucherStripePaymentMutation(
            payload
          ).unwrap();

          if (response.voucherCode) {
            const indexDBStore = new KolulaStorageManager();
            await indexDBStore.deletePersonalData();
            dispatch(paymentCompleted(response));
            dispatch(
              enqueueNotification({
                severity: "success",
                message: t("book_location.payment.success_voucher"),
              })
            );
          }

          return response;
        }
      } catch (error) {
        dispatch(paymentCompletionFailed());
        dispatch(
          enqueueNotification({
            severity: "error",
            message: t("book_location.payment.error_voucher"),
          })
        );

        Logger.for("Complete Voucher Payment").error(error);
        ErrorTracker.trackException(error as Error);
        // Handle the error state or dispatch error actions if necessary
      }
    },
    [contact, completeVoucherStripePaymentMutation, dispatch]
  );
};
